import React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const AddIcon = (props) => {
  const {fill= 'var(--primary)'} = props;
  return (
    <SvgIcon {...props} width="18" height="18" viewBox="0 0 18 18">
        <path id="Path_610" data-name="Path 610" d="M155,392.333V395m0,0v2.667M155,395h2.667M155,395h-2.667M163,395a8,8,0,1,1-8-8A8,8,0,0,1,163,395Z"
              transform="translate(-146 -386)" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
    </SvgIcon>
  );
};

export default AddIcon;
